<template>
  <div class="text-center relative text-flamingo-950 dark:text-dark-50">
    <div class="bg-cover h-40 absolute top-0 w-full dark:opacity-80" :class="[ isRounded ? 'rounded-t-3xl' : '']" :style="{ backgroundImage: `url(${colorTheme === 'dark' ? gradientDark : gradientExplorer})` }">
      <div class="bg-gradient-to-t h-2/6 absolute bottom-0 left-0 right-0 from-flamingo-50 to-flamingo-50/0 dark:from-dark-920 dark:to-dark-920/0"/>
    </div>

    <div class="px-4" :class="[ isFull ? 'pt-4' : '']">
      <div class="size-14 bg-white border border-flamingo-100 rounded-full flex items-center justify-center shadow-md shadow-flamingo-800/10 mx-auto relative z-10">
        <ImageEmoji name="Heart+Hands" class="size-6" />
      </div>

      <p class="font-bold text-white text-xl !leading-tight mt-2 relative" v-html="$t('components.Subscribe.title')" />

      <template v-if="userReferral">
        <UserPicture :user="userReferral" size="md" class="mx-auto mt-3 mb-1 rounded-full relative z-10" />
        <p class="font-medium mt-2">
          {{ $t('components.Subscribe.referral.testimony', {
            name: userReferral.name,
            date: dayjs(userReferral.createdAt).fromNow(true)
          }) }}
        </p>
      </template>
      <template v-else>
        <img src="https://vibes-production.s3.eu-west-3.amazonaws.com/users/64be31001e21730014de5b15/profile/xSFUwIecy-s.jpeg" class="size-10 relative z-10 mt-3 mb-1 mx-auto rounded-full" />
        <p class="font-medium mt-2 relative" v-html="$t('components.Subscribe.subtitle')" />
        <p class="font-bold text-sm mt-2">{{ $t('pages.onboarding.profiles.signature') }}</p>
      </template>

      <div class="z-10 h-12 pointer-events-none text-left bg-charcoal-300/50 dark:bg-dark-920 rounded-full relative mt-4">
        <Transition name="slide-up" mode="out-in">
          <div class="bg-charcoal-950 dark:bg-dark-800 dark:text-dark-50 text-white rounded-full flex items-center pl-1.5 pr-5 text-left space-x-3 h-12 shadow" :key="latestMember._id" v-if="latestMember">
            <div class="flex items-center space-x-2">
              <UserPicture :user="latestMember" size="sm" />
            </div>
            
            <div>
              <p class="line-clamp-1 text-sm font-medium break-all !leading-none">
                {{ $t('components.Subscribe.subscribed', { name: latestMember.name }) }}
              </p>
              <p class="text-xs text-charcoal-500 dark:text-charcoal-400 !leading-none mt-0.5" v-if="latestMember.subscribedAt">
                {{ latestMember.city }} · {{ dayjs(latestMember.subscribedAt).fromNow() }}
              </p>
            </div>
          </div>
        </Transition>
      </div>

      <div class="text-left overflow-hidden mt-6">
        <div class="space-y-3">
          <div class="flex items-start space-x-2.5" v-for="feature in features.filter(f => f.subtitle)">
            <div class="size-12 rounded-xl flex items-center justify-center shrink-0 bg-urchin-100 dark:bg-dark-800">
              <ImageEmoji :name="feature.image ?? ''" class="size-8" />
            </div>

            <div class="mt-1">
              <p class="text font-bold !leading-tight">{{ feature.title }}</p>
              <p class="text-light-950/50 dark:text-dark-400 font-medium text-sm !leading-tight mt-0.5">{{ feature.subtitle }}</p>
            </div>
          </div>
          <UserProfileBlockMin :user="exampleProfile" :theme="theme" class="grow" />
        </div>
        <div class="grid grid-cols-2 gap-x-1 gap-y-2 border-t p-2.5 mt-4 bg-urchin-100 border-urchin-100 text-urchin-950 rounded-xl">
          <div class="flex items-center space-x-1.5" v-for="feature in features.filter(f => !f.subtitle)">
            <div class="size-8 rounded flex items-center shrink-0 justify-center bg-urchin-300/50">
              <ImageEmoji :name="feature.image ?? ''" class="size-5 shrink-0" />
            </div>

            <div class="text-xs font-medium leading-none">
              {{ feature.title }}
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="grid grid-cols-2 gap-1.5 mt-6 text-white" v-if="hasClubPartners">
        <div v-for="partner in partners.slice(0, 4)">
          <div class="bg-cover p-1 bg-center rounded-xl h-28 flex flex-col items-center justify-center overflow-hidden relative cursor-pointer" :style="{ backgroundImage: `url(${partner.banner?.getSize('s')})` }" @click="() => isPartnersPopin = true">
            <div class="absolute top-0 left-0 w-full h-full bg-charcoal-950/40" />

            <p class="font-bold relative text-sm mb-0.5">{{ partner.name }}</p>
            <div class=" border border-white/20 bg-charcoal-800/80 px-3 py-1 font-bold text-xs leading-tight rounded-full z-10" v-if="partner.offers[0]">
              {{ partner.offers[0].title }}
            </div>
          </div>
        </div>

        <div class="col-span-2 pt-1">
          <ButtonBase color="white" size="xs" @click="() => isPartnersPopin = true">
            <span class="px-2">
              {{ $t('actions.showAll') }}
            </span>
          </ButtonBase>
        </div>
      </div> -->

      <NonprofitBlock class="mt-4" is-subscribe v-if="nonprofit" />

      <div class="mt-8 space-y-1 text-left">
        <div class="bg-charcoal-100 dark:bg-dark-800 rounded-md" v-for="(question, i) in questions">
          <div
            class="flex items-center py-3.5 px-3.5 space-x-2"
            :class="[
              expandedItem === i ? '' : 'text-dark-800 dark:text-dark-50'
            ]" 
            @click="expandedItem = i"
          >
            <div class="grow text-base !leading-tight font-bold" v-html="question.title" />
            <IconBase name="cute/angle-right" :width="18" class="transition shrink-0" :class="[ expandedItem === i ? 'rotate-90' : '']" />
          </div>
          <div class="pb-3.5 px-3.5 leading-normal" v-if="expandedItem === i" v-html="question.content" />
        </div>
      </div>

      <div class="mt-6 opacity-60 text-xs rounded-xl leading-tight mb-16 space-y-3 font-medium">
        <div>{{ $t('components.Subscribe.disclaimer') }}</div>
        <div v-html="$t('components.Subscribe.disclaimerLinks')" />
      </div>
    </div>

    <div class="bg-white dark:bg-dark-800 sticky bottom-0 left-0 right-0 z-50 rounded-t-3xl overflow-hidden w-full -mb-inset-bottom" :class="[ isFull ? 'pb-inset-bottom' : '']" :style="{ boxShadow: `0 0 24px 0 rgba(0, 0, 0, 0.25)` }">
      <div class="p-3.5 space-y-2 max-w-wrapper-xs mx-auto text-light-950 dark:text-dark-50">
        <template v-if="Capacitor.isNativePlatform()">
          <div class="flex items-center justify-between" v-if="!currentUser?.isSubscriber">
            <p class="font-bold text-sm">{{ $t('components.Subscribe.payment.title') }}</p>

            <ButtonLink size="sm" class="-mt-1" @click="() => isPriceInfo = !isPriceInfo" v-if="discountPrices[0]">
              {{ isPriceInfo ? $t('actions.close') : $t('components.Subscribe.discount.title') }}
            </ButtonLink>
          </div>
          <Transition name="fade">
            <div class="text-left text-sm p-4 rounded-xl !mt-3 !mb-3 bg-charcoal-100 dark:bg-dark-700" v-if="isPriceInfo">
              <template v-if="!currentUser?.isSolidarity">
                <div v-html="$t('components.Subscribe.discount.intro', { price: discountPrices[0]?.product?.priceString })" />
                <ButtonBase size="2xs" color="white" class="mt-4" is-full @click="() => isDiscountPrice = true">{{ $t('components.Subscribe.discount.request') }}</ButtonBase>
              </template>
              <template v-else>
                {{ $t('components.Subscribe.discount.active') }}

                <ButtonBase size="xs" color="white" class="mt-3" is-full @click="() => { subscriptionType = 'base'; isPriceInfo = false; }" v-if="subscriptionType === 'solidarity'">
                  {{ $t('components.Subscribe.discount.normalPrices') }}
                </ButtonBase>
                <ButtonBase size="xs" color="white" class="mt-3" is-full @click="() => { subscriptionType = 'solidarity'; isPriceInfo = false; }" v-else>
                  {{ $t('components.Subscribe.discount.discountPrices') }}
                </ButtonBase>
              </template>
            </div>
          </Transition>
          <div class="grid grid-cols-3 gap-1" v-if="!currentUser?.isSubscriber">
            <div
              class="bg-charcoal-200 dark:bg-dark-700 cursor-pointer min-h-20 flex flex-col rounded-lg bg-cover transition text-center border border-charcoal-200 dark:border-dark-600 p-1"
              :style="{
                ...(currentPrice?.id === price.id ? { backgroundImage: `url(${price.bg})` } : {})
              }"
              v-for="(price, i) in prices"
              @click="() => currentPrice = price"
            >
              <UserPicture :user="userReferral" size="2xs" class="-mt-4 mx-auto" v-if="price.promotional && userReferral" />

              <div class="text-2xs font-bold text-white -mb-1" v-if="price.promotional">
                {{ $t('components.Subscribe.referral.offer') }}
              </div>

              <div class="grow p-1 flex items-center justify-center flex-col" :class="[
                currentPrice?.id === price.id ? 'text-white' : 'text-charcoal-500'
              ]">
                <p class="font-bold text-lg !leading-none">{{ price.duration }} {{  $t('moment.months', price.duration) }}</p>
                <p class="text-xs">
                  <span v-if="price.promotional">
                    {{ price.promotional?.price?.amount }}{{ getCurrency(price.promotional?.price?.currencyCode) }}<br>
                  </span>
                  <span :class="[ price.promotional ? 'line-through' : '']">
                    {{ price.product?.price }}{{ getCurrency(price.product?.currencyCode) }}
                  </span>
                </p>
              </div>
              <div class="shrink-0 bg-white dark:bg-dark-950 p-1 rounded-full" v-if="price.duration > 1">
                <p class="text-3xs font-medium">
                  {{ round(((price.promotional?.price?.amount ?? price.product?.price ?? 0) - 0.01) / price.duration, 2) }}€/{{ $t('moment.months', 1)}}
                </p>
              </div>
            </div>
          </div>

          <div class="flex items-center space-x-1.5 relative z-10">
            <ButtonBase size="sm" color="white" class="shrink-0" @click="() => welcomeOffer ? isWarning = true : emit('skip')" :timer="5" v-if="isSkippable">
              {{ $t('actions.skip') }}
            </ButtonBase>
            
            <ButtonBase size="sm" is-full @click="() => onPurchase()" :is-disabled="!currentPrice" v-if="!currentUser?.isSubscriber">
              {{ $t('components.Subscribe.submit') }}
            </ButtonBase>
          </div>

          <ButtonBase color="white" :is-loading="isLoading" is-full @click="onEdit" v-if="isEdit && currentUser?.isSubscriber">
            {{ $t('components.Subscribe.cancel') }}
          </ButtonBase>
        </template>
        <div class="bg-charcoal-100 dark:bg-dark-900 p-3 rounded-xl text-sm font-medium" v-else>
          <p>{{ $t('components.Subscribe.unavailable.title') }}</p>

          <div class="flex items-center space-x-1.5 mt-4">
            <ButtonBase color="white" size="sm" @click="() => welcomeOffer ? isWarning = true : emit('skip')" v-if="isSkippable">
              {{ $t('actions.skip') }}
            </ButtonBase>

            <ButtonBase is-full size="sm" :href="downloadLink" target="_blank">
              {{ $t('actions.downloadApp') }}
            </ButtonBase>
          </div>
        </div>
      </div>
    </div>

    <PopinBase size="3xs" :is-active="isDiscountPrice" @close="isDiscountPrice = false">
      <template #body>
        <div class="p-5 text-left leading-normal relative">
          <p class="font-bold text-md">{{ $t('components.Subscribe.discount.title') }}</p>
          <p class="!leading-snug text-sm mb-3 mt-1">
            {{ $t('components.Subscribe.discount.content') }}
          </p>

          <InputTextarea v-model="discountMessage" :min="100" class="border border-charcoal-200 rounded-md bg-white dark:bg-dark-800 dark:text-dark-50 dark:border-dark-700 p-3 mb-3" :rows="3" :placeholder="$t('components.Subscribe.discount.placeholder')"/>

          <div class="text-cobra-600 bg-cobra-100 rounded-2xl p-3 font-medium text-sm text-center" v-if="isDiscountSuccess">
            {{ $t('components.Subscribe.discount.success') }}
          </div>
          <div class="text-light-600 bg-light-100 dark:bg-dark-800 dark:text-dark-50 rounded-2xl space-y-2 p-3 font-medium text-sm text-center" v-else>
            <ButtonBase color="white" size="sm" :is-loading="isLoading" @click="() => onSubmitDiscount()" is-full :is-disabled="discountMessage.length < 10">
              {{ $t('components.Subscribe.discount.submit') }}
            </ButtonBase>

            <div class="text-xs leading-tight" v-html="$t('components.Subscribe.discount.footer')" />
          </div>
        </div>
      </template>
    </PopinBase>

    <PopinBase size="3xs" :is-active="isWarning" @close="isWarning = false">
      <template #body>
        <div class="p-4 space-y-2 text-left leading-normal relative">
          <div>
            <p class="font-bold text-md">{{ $t('components.Subscribe.offer.welcomeTitle') }}</p>
            <p class="!leading-snug text-sm">{{ $t('components.Subscribe.offer.welcomeContent') }}</p>
          </div>

          <div class="bg-royal-600 text-white p-4 rounded-2xl bg-cover bg-center" :style="{ backgroundImage: `url(${gradientPioneer})` }">
            <div class="flex items-baseline space-x-1.5" v-if="Capacitor.getPlatform() === 'ios'">
              <p class="text-5xl font-bold leading-none">{{ welcomeOfferProduct?.priceString }}</p>
              <p class="line-through">{{ supporterPrices[0]?.product?.priceString }}</p>
            </div>
            <div class="flex items-baseline space-x-1.5" v-else-if="Capacitor.getPlatform() === 'android'">
              <p class="text-5xl font-bold leading-none">{{ (welcomeOffer as SubscriptionOption).pricingPhases[0]?.price.formatted }}</p>
              <p class="line-through">{{ supporterPrices[0]?.product?.priceString }}</p>
            </div>

            <p class="leading-tight font-bold">{{ $t('components.Subscribe.offer.firstMonth') }}</p>
            <p class="leading-tight text-xs opacity-80 mt-2">
              {{ $t('components.Subscribe.offer.normalPrice', { price: supporterPrices[0]?.product?.priceString }) }}
            </p>
          </div>

          <div class="text-light-600 bg-light-100 dark:bg-dark-800 dark:text-dark-50 rounded-2xl space-y-2 p-3 font-medium text-sm text-center">
            <ButtonBase color="builders" class="z-10" is-full @click="() => onPurchase(true)">
              {{ $t('components.Subscribe.offer.welcomeAction') }}
            </ButtonBase>
            
            <ButtonBase color="white" size="xs" @click="emit('skip')" is-full>
              {{ $t('components.Subscribe.skip') }}
            </ButtonBase>

            <p class="text-xs leading-tight">
              {{ $t('components.Subscribe.offer.last') }}
            </p>
          </div>

          <div class="z-[999] bg-light-100 dark:bg-dark-800 flex items-center justify-center fixed top-0 left-0 w-full h-full" v-if="isPaying">
            <IconBase name="cute/spinner" class="spin text-light-400 dark:text-dark-100" />
          </div>
        </div>
      </template>
    </PopinBase>

    <PopinBase :is-active="isErrorFetch" size="2xs" color="whale" :z="301" @close="router.push({ name: isSkippable ? 'app-onboarding-welcome' : 'app' })">
      <template #body>
        <div class="p-8 md:p-12 text-white text-sm font-medium leading-relaxed" v-html="$t('components.Subscribe.error.content')" />
      </template>
      <template #footer>
        <div class="p-2">
          <ButtonBase :to="{ name: isSkippable ? 'app-onboarding-welcome' : 'app' }" color="white">
            {{ $t('actions.continue') }}
          </ButtonBase>
        </div>
      </template>
    </PopinBase>

    <PopinBase :is-active="isEditError" size="3xs" :z="301" @close="isEditError = false">
      <template #body>
        <div class="p-8 md:p-12 text-center leading-normal">
          {{ $t('components.Subscribe.error.cancel') }}
        </div>
      </template>
    </PopinBase>

    <!-- PARTNERS -->
    <PopinBase :is-active="isPartnersPopin" color="whale" size="2xs" :z="301" @close="isPartnersPopin = false">
      <template #body>
        <div class="p-8 text-center text-white">
          <ImageEmoji name="Victory+Hand" class="mx-auto size-14 mb-3" />
          <p class="text-3xl font-bold mb-1.5">{{ $t('components.Subscribe.club.title') }}</p>
          <p class="font-medium leading-snug">{{ $t('components.Subscribe.club.content') }}</p>

          <div class="grid grid-cols-2 gap-x-2 gap-y-6 mt-6 -mx-3">
            <div v-for="partner in partners">
              <div class="bg-cover p-1 bg-center rounded-xl h-36 flex items-center justify-center overflow-hidden relative" :style="{ backgroundImage: `url(${partner.banner?.getSize('s')})` }">
                <div class="absolute top-0 left-0 w-full h-full bg-charcoal-950/40" />

                <div class="border border-white/20 bg-charcoal-800/80 px-3 py-1 font-bold text-xs leading-tight rounded-full z-10" v-if="partner.offers[0]">
                  {{ partner.offers[0].title }}
                </div>
              </div>

              <p class="font-bold mt-3">{{ partner.name }}</p>
              <p class="font-medium text-xs line-clamp-2">{{ partner.summary }}</p>
            </div>
          </div>

          <div class="text-xs bg-whale-900 p-4 font-medium rounded-xl -mx-3 mt-6">
            {{ $t('components.Subscribe.club.disclaimer') }}
          </div>
        </div>
      </template>
    </PopinBase>

    <div class="z-[999] bg-white/90 flex items-center justify-center fixed top-0 left-0 w-full h-full" v-if="isPaying">
      <IconBase name="cute/spinner" class="spin text-charcoal-300" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import gradientEarlybird from '@/assets/img/gradients/hard/gradient-8.jpg'
import gradientExplorer from '@/assets/img/gradients/hard/gradient-2.jpg'
import gradientDark from '@/assets/img/gradients/hard/gradient-17.jpg'
import gradientPioneer from '@/assets/img/gradients/hard/gradient-3.jpg'
import UserStore from '@/store/user'
import UsersStore from '@/store/users'
import { products, purchaseProduct, Product, restorePurchases, offerGet, Price, supporterPrices, welcomeOffer, welcomeOfferProduct, initPrices } from '@/utils/native/useIAP'
import { subscribersGetAPI } from '@/api/users'
import { Capacitor } from '@capacitor/core'
import { User } from '@/classes'
import person from '@/assets/img/person/person0.jpg'
import { getCurrency } from '@/static/currencies'
import { getDownloadLink } from '@/utils/native/useDevice'
import { PurchasesPromotionalOffer, PurchasesStoreProductDiscount, SubscriptionOption } from '@revenuecat/purchases-capacitor'
import dayjs from 'dayjs'
import { AppsFlyer } from 'appsflyer-capacitor-plugin'

withDefaults(defineProps<{
  isSkippable?: boolean
  isReminder?: boolean
  isEdit?: boolean
  isFree?: boolean
  isFull?: boolean
  isRounded?: boolean
}>(), {
  isFree: false,
  isRounded: false,
  isReminder: false,
  isFull: false,
  isEdit: false,
  isSkippable: true
})

const emit = defineEmits<{
  (e: 'skip'): void
  (e: 'success'): void
}>()

const usersStore = UsersStore()
const userStore = UserStore()
const { currentUser, nonprofit, colorTheme } = storeToRefs(userStore)

const userReferral = computed(() => currentUser.value?.referral ? usersStore.getItem(currentUser.value.referral) : null)

const router = useRouter()
const expandedItem = ref(999)
const subscriptionType: Ref<'base' | 'solidarity'> = ref(currentUser.value?.isSolidarity ? 'solidarity' : 'base')
const isPriceInfo = ref(false)

const features = computed(() => [
  {
    title: useNuxtApp().$i18n.t('components.Subscribe.perks.boost.title'),
    subtitle: useNuxtApp().$i18n.t('components.Subscribe.perks.boost.subtitle'),
    image: 'Rocket'
  },
  {
    title: useNuxtApp().$i18n.t('components.Subscribe.perks.messages.title'),
    subtitle: useNuxtApp().$i18n.t('components.Subscribe.perks.messages.subtitle'),
    image: 'Love+Letter'
  },
  {
    title: useNuxtApp().$i18n.t('components.Subscribe.perks.distance.title'),
    subtitle: useNuxtApp().$i18n.t('components.Subscribe.perks.distance.subtitle'),
    image: 'Infinity'
  },
  {
    title: useNuxtApp().$i18n.t('components.Subscribe.perks.visits.title'),
    subtitle: useNuxtApp().$i18n.t('components.Subscribe.perks.visits.subtitle'),
    image: 'Eyes'
  },
  {
    title: useNuxtApp().$i18n.t('components.Subscribe.perks.boosts.title'),
    subtitle: useNuxtApp().$i18n.t('components.Subscribe.perks.boosts.subtitle'),
    image: 'High+Voltage'
  },
  ...(nonprofit.value ? [
    {
      title: useNuxtApp().$i18n.t('components.Subscribe.perks.nonprofit.title'),
      subtitle: nonprofit.value.title,
      image: 'Coin'
    },
  ] : []),
  {
    title: useNuxtApp().$i18n.t('components.Subscribe.perks.ads.title'),
    image: 'Name+Badge'
  },
  {
    title: useNuxtApp().$i18n.t('components.Subscribe.perks.filters.title'),
    image: 'Magnifying+Glass+Tilted+Right'
  },
  {
    title: useNuxtApp().$i18n.t('components.Subscribe.perks.incognito.title'),
    image: 'Face+in+Clouds'
  },
  {
    title: useNuxtApp().$i18n.t('components.Subscribe.perks.readMarks.title'),
    image: 'Check+Mark+Button'
  }
])

const questions = computed(() => {

  return [
    {
      title: useNuxtApp().$i18n.t('components.Subscribe.faq.free.title'),
      content: useNuxtApp().$i18n.t('components.Subscribe.faq.free.content')
    },
    {
      title: useNuxtApp().$i18n.t('components.Subscribe.faq.apps.title'),
      content: useNuxtApp().$i18n.t('components.Subscribe.faq.apps.content')
    },
    // ...(hasClubPartners.value ? [
    //   {
    //     title: useNuxtApp().$i18n.t('components.Subscribe.faq.club.title'),
    //     content: useNuxtApp().$i18n.t('components.Subscribe.faq.club.content')
    //   }
    // ] : [])
  ] 
})

const latestMembers: Ref<string[]> = ref([])

const isPartnersPopin = ref(false)

const { data: latestMember, refresh } = useLazyAsyncData(Math.random().toString(), async () => {
  const response = await subscribersGetAPI({
    exclude: latestMembers.value
  })

  if (response.ok && response.data?.users[0]) {
    latestMembers.value = [
      response.data.users[0]._id,
      ...latestMembers.value
    ].slice(0, 15)

    return new User(response.data.users[0])
  } else {
    latestMembers.value = []
  }

  return null
}, {
  server: false
})

// PROFILES

const theme = ref('cherry')
const banner = ref('')

const exampleProfile = computed(() => ({
  name: currentUser.value?.name,
  pronouns: [],
  mainFlag: 'lgbtqia',
  isSubscriber: true,
  image: {
    getSize: () => currentUser.value?.image?.getSize('s') ?? person
  },
  '@profile': {
    bio: useNuxtApp().$i18n.t('components.Subscribe.profile'),
    banner: banner.value
  }
})) as unknown as User

// SLIDER

const currentPrice: Ref<Price | null> = ref(null)
const discountPrices : ComputedRef<Price[]> = computed(() => [
  {
    id: 'pioneer',
    product: products.value.find(p => p.identifier.includes('solidarity')),
    duration: 1,
    bg: gradientEarlybird
  }
].filter(p => p.product))

const prices: ComputedRef<Price[]> = computed(() => {

  return subscriptionType.value === 'base' ? supporterPrices.value : discountPrices.value
})

// INTRO PRICE

const isWarning = ref(false)
const isEditError = ref(false)

const onEdit = async () => {
  const entitlement = (currentUser.value?.entitlements ?? []).find(e => e.type === 'member')

  if (!entitlement) return

  isEditError.value = false
  isLoading.value = true

  if (entitlement.manageUrl) {
    window.location = entitlement.manageUrl as unknown as Location
  } else {
    isEditError.value = true
  }

  isLoading.value = false
}

// PAYMENT

const isLoading = ref(false)
const isPaying = ref(false)
const isError = ref(false)
const isErrorFetch = ref(false)

const route = useRoute()

const onPurchase = async (
  isWelcomeOffer?: boolean
) => {
  isLoading.value = true
  isPaying.value = true

  let step = 'start'

  useNuxtApp().$amplitude.logEvent(`Paywall_Start`, {
    source: route.fullPath
  })

  try {
    const product = currentPrice.value?.product

    if (!product) throw Error('error')

    if (isWelcomeOffer) {
      step = 'welcome-start'

      if (!welcomeOffer.value) throw Error('error')

      const result = await purchaseProduct(product, {
        ...(Capacitor.getPlatform() === 'ios' ? { discount: welcomeOffer.value as PurchasesPromotionalOffer } : {}),
        ...(Capacitor.getPlatform() === 'android' ? { option: welcomeOffer.value as SubscriptionOption } : {})
      })

      if (!result) throw Error('error')
    } else {
      const offer = currentPrice.value?.promotional?.offer
      step = 'product'

      const result = await purchaseProduct(product, {
        ...(offer && Capacitor.getPlatform() === 'ios' ? { discount: offer as PurchasesPromotionalOffer } : {}),
        ...(offer && Capacitor.getPlatform() === 'android' ? { option: offer as SubscriptionOption } : {})
      })

      step = 'purchase-after'

      if (!result) throw Error('error')
    }
  
    const isSubscribeSuccessful = await retry(async (i: number) => {
      if (i === 4) await restorePurchases()
      await userStore.initUser(true)
    }, computed(() => currentUser.value?.isSubscriber), 2000, 6)

    if (!isSubscribeSuccessful) {
      isErrorFetch.value = true
      throw Error('error')
    }

    useNuxtApp().$amplitude.logEvent(`Paywall_Complete`, {
      source: route.fullPath
    })

    if (Capacitor.isNativePlatform()) {
      AppsFlyer.logEvent({
        eventName: 'af_purchase'
      })
    }

    emit('success')
  } catch (e) {
    console.error(JSON.stringify({
      error: e,
      step,
      message: (e as any)?.message ?? 'unknown'
    }))

    useNuxtApp().$amplitude.logEvent(`Error`, {
      type: 'paywall',
      info: JSON.stringify({
        error: e,
        step,
        message: (e as any)?.message ?? 'unknown'
      }),
    })

    isError.value = true
  }

  isPaying.value = false
  isLoading.value = false
}

// DISCOUNT
const isDiscountPrice = ref(false)
const isDiscountSuccess = ref(false)
const discountMessage = ref('')

const onSubmitDiscount = async () => {
  isLoading.value = true

  const response = await fetchAPI('user/subscriptions/discount', {
    request: discountMessage.value
  }, { method: 'POST' })

  if (response.ok) {
    isDiscountSuccess.value = true
  }

  isLoading.value = false
}

const intervals: Ref<any[]> = ref([])
const { link: downloadLink } = getDownloadLink()

onMounted(async () => {
  const themes = [ 
    { theme: 'fireplace', banner: 'https://media1.tenor.com/m/i22Batz8ryoAAAAd/lofi.gif' },
    { theme: 'cherry', banner: 'https://media1.tenor.com/m/W6DlKhLnLboAAAAd/anime-food.gif' },
    { theme: 'galaxy', banner: 'https://media1.tenor.com/m/sktvOV9L-GMAAAAd/anime-nighttime.gif' },
    { theme: 'amethyst', banner: 'https://media1.tenor.com/m/OWPswdh5zpEAAAAd/purple-anime.gif' },
    { theme: 'sunflower', banner: 'https://media1.tenor.com/m/LESzyj0LyJkAAAAd/anime-cheers-anime-alcohol.gif' },
    { theme: 'cloud', banner: 'https://media1.tenor.com/m/52-erqoYMgsAAAAd/anime-nature.gif' },
    { theme: 'wood', banner: 'https://media1.tenor.com/m/1Xat-QWmr-oAAAAd/pom-poko-studio-ghibli.gif' },
    { theme: 'charcoal', banner: 'https://media1.tenor.com/m/VEDQhRxMQLkAAAAd/paint-nails.gif' },
    { theme: 'pond', banner: 'https://media1.tenor.com/m/44W7Kpj5yOcAAAAd/8bit.gif' },
    { theme: 'ruby', banner: 'https://media1.tenor.com/m/27_DLpwr6gQAAAAd/welcome-roses.gif' },
    { theme: 'mouse', banner: 'https://media1.tenor.com/m/2drArMY6A_cAAAAd/anime-milk.gif' },
  ]

  let i = 0
  theme.value = themes[i].theme
  banner.value = themes[i].banner

  const interval1 = setInterval(() => {
    theme.value = themes[i].theme
    banner.value = themes[i].banner

    i = i >= themes.length - 1 ? 0 : i + 1
  }, 1500)

  const interval2 = setInterval(() => {
    console.log('Refreshing latest member')
    refresh()
  }, 3000)

  intervals.value = [ interval1, interval2 ]

  if (subscriptionType.value === 'base') {
    if (supporterPrices.value[1]) currentPrice.value = supporterPrices.value[1] ?? null
  } else {
    if (discountPrices.value[0]) currentPrice.value = discountPrices.value[0] ?? null
  }

  await userStore.initUser(true)
  await userStore.getUpdates(false)
})

onBeforeUnmount(() => {
  intervals.value.map(interval => clearInterval(interval))
})
</script>
